export default __webpack_public_path__ + "static/5-new-article-7abe1a289f162aab69a574c01e808017.jpg";